import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { saveConfigurationTemplate } from '@api/configurationTemplates';

import { IConfigurationTemplate } from '@interfaces/cmModule/configurationTemplates';
import { IConfigurationTemplateSaveDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONFIGURATION_TEMPLATES, CONFIGURATION_TEMPLATES_SET } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseQueryConfigurationTemplatesConfigTreeReturned {
	savedTemplateTree: IConfigurationTemplate | undefined;
	isLoadingSaveTemplatesTree: boolean;
	saveTemplateTree: UseMutateFunction<any, any, IConfigurationTemplateSaveDTO, any>;
}

const useMutateConfigurationSaveTemplatesTree = ({
	onSuccess,
}: Partial<IOnSuccess>): IUseQueryConfigurationTemplatesConfigTreeReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		data,
		mutateAsync,
		isLoading,
	} = useMutation<IConfigurationTemplateSaveDTO, IConfigurationTemplate>({
		mutationKey: [CONFIGURATION_TEMPLATES_SET],
		mutationFn: saveConfigurationTemplate,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.createConfigurationTemplate,
				type: ESnackbarTypes.success,
			}));

			if (onSuccess) {
				onSuccess();
			}

			return queryClient.invalidateQueries([CONFIGURATION_TEMPLATES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		savedTemplateTree: data,
		saveTemplateTree: mutateAsync,
		isLoadingSaveTemplatesTree: isLoading,
	};
};

export default useMutateConfigurationSaveTemplatesTree;
